.agency_btn {
  border-radius: var(--mantine-radius-sm);
  transition:
    background-color 0.2s ease,
    color 0.2s ease;
  height: 44px;
  padding: var(--mantine-spacing-xs) var(--mantine-spacing-sm);
  min-width: 0;
  width: 100%;

  &:hover {
    background-color: var(--mantine-color-gray-3);
    color: var(--theme-text-primary-hover);
  }

  &:active {
    background-color: var(--mantine-color-gray-2);
    color: var(--theme-text-primary-active);
  }
}

.chevron {
  transition: transform 0.2s ease;

  &[data-opened] {
    transform: rotate(-180deg);
  }
}
